import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'm14.3 4.152-1.5-2a2.259 2.259 0 0 0-1.8-.9H5a2.274 2.274 0 0 0-1.8.9l-1.5 2a2.28 2.28 0 0 0-.45 1.35v7a2.253 2.253 0 0 0 2.25 2.25h6v-1.5h-6a.755.755 0 0 1-.75-.75v-6.75h10.5V8h1.5V5.5a2.28 2.28 0 0 0-.45-1.348Zm-10.8.1.9-1.2a.753.753 0 0 1 .6-.3h6a.739.739 0 0 1 .6.3l.9 1.2Zm11.03 7.28a.786.786 0 0 1-.53.22.767.767 0 0 1-.53-.22l-.97-.97V14a.75.75 0 0 1-1.5 0v-3.44l-.97.97a.75.75 0 0 1-1.06-1.06l2.25-2.25a.741.741 0 0 1 .38-.2.572.572 0 0 1 .3 0 .741.741 0 0 1 .38.2l2.25 2.25a.754.754 0 0 1 .001 1.062Z';
const draw24px = 'M20.2,7.019l-2-2.67a2.766,2.766,0,0,0-2.2-1.1H8a2.752,2.752,0,0,0-2.2,1.1l-2,2.67a2.728,2.728,0,0,0-.55,1.65V18A2.748,2.748,0,0,0,6,20.749h7.75v-1.5H6A1.25,1.25,0,0,1,4.751,18V8.749h14.5l-.01,3h1.5l.01-3.08A2.8,2.8,0,0,0,20.2,7.019Zm-14.7.23,1.5-2a1.26,1.26,0,0,1,1-.5h8a1.275,1.275,0,0,1,1,.5l1.5,2Zm15.03,9.28a.742.742,0,0,1-.53.22.71.71,0,0,1-.53-.22l-1.72-1.72V20a.75.75,0,0,1-1.5,0v-5.19l-1.72,1.72a.75.75,0,0,1-1.06-1.06l3-3a.683.683,0,0,1,.28-.17.534.534,0,0,1,.25-.05.772.772,0,0,1,.15.02.741.741,0,0,1,.38.2l3,3A.754.754,0,0,1,20.531,16.529Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const BoxArrowUpIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'boxArrowUp'));
BoxArrowUpIcon.displayName = 'BoxArrowUpIcon';
BoxArrowUpIcon.propTypes = Icon.propTypes;
BoxArrowUpIcon.renderIcon = props => /*#__PURE__*/React.createElement(BoxArrowUpIcon, props);
export default BoxArrowUpIcon;
//# sourceMappingURL=BoxArrowUpIcon.js.map